/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 失败遮罩组件
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-12-09 14:44:41
 */

import React from 'react'

import './FailedOverlay.scss'
import { ExclamationCircleOutlined } from '@ant-design/icons'

declare const __RELEASE_STAGE__: string

// 失败遮罩组件 Props
export interface FailedOverlayProps {
  errorMsg?: string
  defaultMsg: string
  reason?: string
  taskID?: string
}

/**
 * 失败遮罩组件
 * 用于显示照片提取失败或编辑失败的遮罩层
 */
const FailedOverlay: React.FC<FailedOverlayProps> = ({
  errorMsg,
  defaultMsg,
  reason,
  taskID
}) => {
  return (
    <div className="failed-overlay">
      <div className="failed-content">
        <ExclamationCircleOutlined
          style={{
            fontSize: 32,
            color: 'rgba(245, 34, 45, 0.8)',
            marginBottom: '18px'
          }}
        />
        <div className="failed-text">{errorMsg || defaultMsg}</div>
        {/* 测试环境显示 reason */}
        {__RELEASE_STAGE__ !== 'production' && reason && (
          <div
            className="failed-text"
            style={{
              marginTop: '8px',
              fontSize: '12px',
              opacity: 0.8
            }}
          >
            reason: {reason}
          </div>
        )}
        {/* 测试环境显示 taskId */}
        {__RELEASE_STAGE__ !== 'production' && taskID && (
          <div
            className="failed-text"
            style={{
              marginTop: '8px',
              fontSize: '12px',
              opacity: 0.8
            }}
          >
            taskId: {taskID}
          </div>
        )}
      </div>
    </div>
  )
}

export default FailedOverlay
